import logoDans from "../../public/dans-image/logo-dans.png"
import bgHeader from "../../public/hoa-nen-images/bg-header.webp"
import iconSearch from "../../public/hoa-nen-images/search-dollar.png"
import iconCart from "../../public/hoa-nen-images/shopping.png"
import iconUser from "../../public/hoa-nen-images/user.png"
import arrowOutside from "../../public/images/arrow-outside.svg"
import defaultAvatar from "../../public/images/avatar-default.svg"
import imgEmpty from "../../public/images/empty-img.jpg"
import logocms from "../../public/images/logocms.webp"

import googleIcon from "../../public/hoa-nen-images/google-icon.png"
import iconHome from "../../public/hoa-nen-images/home-icon.svg"
import iconMinus from "../../public/hoa-nen-images/minus-product.svg"
import iconPlus from "../../public/hoa-nen-images/plus-product.svg"
import recycleBin from "../../public/hoa-nen-images/recycle-bin.svg"

import imgLeftAuth from "../../public/hoa-nen-images/screen-left-auth.jpg"
import imgRightAuth from "../../public/hoa-nen-images/screen-right-auth.png"

import banner1 from "../../public/hoa-nen-images/banner-1.jpg"
import banner2 from "../../public/hoa-nen-images/banner-2.jpg"
import facebookIcon from "../../public/hoa-nen-images/fb.png"
import googleIconHover from "../../public/hoa-nen-images/google-icon-hover.png"
import instagramIcon from "../../public/hoa-nen-images/ins.png"
import fakesp from "../../public/hoa-nen-images/sp-1.webp"
import iconTick from "../../public/hoa-nen-images/tick.svg"
import tiktokIcon from "../../public/hoa-nen-images/tiktok.png"
import voucher from "../../public/hoa-nen-images/voucher.svg"
import quoteIcon from "../../public/images/icon-Quote.png"
import imageEmpty from "../../public/images/image-empty.png"
import logoEn from "../../public/images/logo-en.png"
import logoVi from "../../public/images/logo-vi.png"

import blogTagIcon from "../../public/CCA-images/blog-tag-icon.svg"
import iconDuration from "../../public/CCA-images/calendar-blank.svg"
import carretDown from "../../public/CCA-images/carret-down.svg"
import carretUp from "../../public/CCA-images/carret-up.svg"
import iconDistance from "../../public/CCA-images/distance.svg"
import facebookFill from "../../public/CCA-images/facebook-fill.svg"
import iconBicycle from "../../public/CCA-images/icon-bicycle.svg"
import instagramFill from "../../public/CCA-images/instagram-fill.svg"
import iconInstagram from "../../public/CCA-images/instagram-icon.svg"
import iconLink from "../../public/CCA-images/link-icon.svg"
import iconLinkedin from "../../public/CCA-images/linkedin-icon.svg"
import logoCCAGreen from "../../public/CCA-images/logo-CCA-green.svg"
import logoCCA from "../../public/CCA-images/logo-CCA.svg"
import menuCloseColapse from "../../public/CCA-images/menu-close-colapse-mobile.svg"
import menuColapse from "../../public/CCA-images/menu-colapse-mobile.svg"
import iconSubmit from "../../public/CCA-images/paper-plane.svg"
import searchIcon from "../../public/CCA-images/search-icon.svg"
import tradeMarkCCA from "../../public/CCA-images/trademark.svg"
import iconTwitter from "../../public/CCA-images/twitter-icon.svg"
import whatappsIcon from "../../public/CCA-images/whatapps-icon.svg"
import zaloIcon from "../../public/CCA-images/zalo-icon.svg"
import arrowLeft from "../../public/dans-image/arrow-left.svg"
import arrowRight from "../../public/dans-image/arrow-right.svg"
import iconBicycleGreen from "../../public/images/icon-bicycle-green.svg"

import accommodationIcon from "../../public/CCA-images/accommodation-icon.svg"
import bedIcon from "../../public/CCA-images/bed-icon.svg"
import bikeIcon from "../../public/CCA-images/bike-icon.svg"
import busIcon from "../../public/CCA-images/bus-icon.svg"
import checkRingRound from "../../public/CCA-images/check-ring-round.svg"
import distanceIcon from "../../public/CCA-images/distance-icon.svg"
import downDistanceIcon from "../../public/CCA-images/down-distance-icon.svg"
import fruitIcon from "../../public/CCA-images/fruit-icon.svg"
import grayDistance from "../../public/CCA-images/gray-distance.svg"
import locactionSummary from "../../public/CCA-images/location-summary.svg"
import locationTimeLine from "../../public/CCA-images/location-time-line.svg"
import logoCCAGreenMobile from "../../public/CCA-images/logo-CCA-green-mobile.svg"
import logoCCATransparentMobile from "../../public/CCA-images/logo-CCA-transparent-mobile.svg"
import logoCCATransparent from "../../public/CCA-images/logo-CCA-transparent.svg"
import mealIcon from "../../public/CCA-images/meal-icon.svg"
import mountain from "../../public/CCA-images/mountain.svg"
import photoIcon from "../../public/CCA-images/photo.svg"
import sessionIcon from "../../public/CCA-images/session-icon.svg"
import speedLight from "../../public/CCA-images/speed-light.svg"
import tag from "../../public/CCA-images/tag.svg"
import time from "../../public/CCA-images/time.svg"
import tourGuideIcon from "../../public/CCA-images/tour-guide-icon.svg"
import upDistanceIcon from "../../public/CCA-images/up-distance-icon.svg"
import verticalDot from "../../public/CCA-images/vertical-dot.svg"

const CCAImages = {
  checkRingRound,
  locactionSummary,
  locationTimeLine,
  mountain,
  speedLight,
  tag,
  time,
  verticalDot,
  grayDistance,
  photoIcon,
  logoCCATransparent,
  logoCCAGreenMobile,
  logoCCATransparentMobile,
  distanceIcon,
  bedIcon,
  downDistanceIcon,
  upDistanceIcon,
  sessionIcon,
  tourGuideIcon,
  accommodationIcon,
  bikeIcon,
  mealIcon,
  busIcon,
  fruitIcon,
}

export const Images = {
  facebookFill,
  instagramFill,
  quoteIcon,
  imgEmpty,
  defaultAvatar,
  logocms,
  logoEn,
  logoVi,
  arrowOutside,
  imageEmpty,
  //new images place here!!!!
  logoDans,
  bgHeader,
  iconSearch,
  iconUser,
  iconCart,
  recycleBin,
  voucher,
  fakesp,
  iconMinus,
  iconPlus,
  iconHome,
  iconTick,
  imgLeftAuth,
  imgRightAuth,
  googleIcon,
  googleIconHover,
  banner1,
  banner2,
  facebookIcon,
  instagramIcon,
  tiktokIcon,
  arrowRight,
  arrowLeft,
  iconBicycleGreen,
  logoCCA,
  logoCCAGreen,
  tradeMarkCCA,
  searchIcon,
  menuColapse,
  menuCloseColapse,
  iconBicycle,
  iconSubmit,
  iconDistance,
  iconDuration,
  whatappsIcon,
  zaloIcon,
  carretDown,
  carretUp,
  iconLink,
  iconLinkedin,
  iconTwitter,
  iconInstagram,
  blogTagIcon,
  ...CCAImages,
}
